module.exports = __webpack_public_path__ + "4c1f5c71c0181bbe3479de80a3333309.png";